(function () {
  if (window.__ukCartConfirmBound) return;
  window.__ukCartConfirmBound = true;

  function rootFrom(el) {
    return el ? el.closest('[data-uk-cart-confirm-root]') : null;
  }

  function cartLooksEmpty(root) {
    return Boolean(
      (root && root.closest('.is-empty')) ||
        document.querySelector('cart-drawer.is-empty, cart-drawer-items.is-empty, #main-cart-footer.is-empty')
    );
  }

  function isRequired() {
    if (window.UkCartConfirm && window.UkCartConfirm.required) return true;
    return Boolean(document.querySelector('#CartDrawer [data-uk-cart-confirm], [data-uk-cart-confirm-wrap]'));
  }

  function confirmText() {
    if (window.UkCartConfirm && window.UkCartConfirm.text) return window.UkCartConfirm.text;
    var el = document.querySelector('#CartDrawer .uk-cart-confirm__text');
    return el ? el.textContent.trim() : '';
  }

  function getRoots() {
    document.querySelectorAll('#main-cart-footer .cart__ctas, #CartDrawer .cart__ctas').forEach(function (el) {
      el.setAttribute('data-uk-cart-confirm-root', '');
    });
    return document.querySelectorAll('[data-uk-cart-confirm-root]');
  }

  function extraButtons(root) {
    var list = [];
    function add(nodeList) {
      nodeList.forEach(function (el) {
        if (list.indexOf(el) === -1) list.push(el);
      });
    }
    add(root.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons'));
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.contains(root)) {
      add(footer.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons'));
    }
    return list;
  }

  function buildCheckbox(id, formId) {
    var wrap = document.createElement('div');
    wrap.className = 'uk-cart-confirm';
    wrap.setAttribute('data-uk-cart-confirm-wrap', '');

    var label = document.createElement('label');
    label.className = 'uk-cart-confirm__label';
    label.setAttribute('for', id);

    var input = document.createElement('input');
    input.id = id;
    input.className = 'uk-cart-confirm__input';
    input.type = 'checkbox';
    input.name = 'attributes[uk_checkout_confirmed]';
    input.value = 'yes';
    input.setAttribute('form', formId);
    input.setAttribute('data-uk-cart-confirm', '');
    input.required = true;

    var text = document.createElement('span');
    text.className = 'uk-cart-confirm__text';
    text.textContent = confirmText();

    label.appendChild(input);
    label.appendChild(text);
    wrap.appendChild(label);
    return wrap;
  }

  function ensureCheckboxes() {
    if (!isRequired()) return;

    getRoots().forEach(function (root) {
      if (root.querySelector('[data-uk-cart-confirm]')) return;

      var isDrawer = Boolean(root.closest('cart-drawer, #CartDrawer'));
      var id = isDrawer ? 'UkCartConfirm-drawer-js' : 'UkCartConfirm-page';
      var formId = isDrawer ? 'CartDrawer-Form' : 'cart';
      var source = document.querySelector('#CartDrawer [data-uk-cart-confirm-wrap]');
      var wrap;

      if (source && !isDrawer) {
        wrap = source.cloneNode(true);
        var input = wrap.querySelector('[data-uk-cart-confirm]');
        var label = wrap.querySelector('label');
        if (input) {
          input.id = id;
          input.setAttribute('form', formId);
          input.checked = false;
        }
        if (label) label.setAttribute('for', id);
      } else {
        wrap = buildCheckbox(id, formId);
      }

      root.insertBefore(wrap, root.firstChild);
    });
  }

  function syncRoot(root) {
    if (!root) return;
    var box = root.querySelector('[data-uk-cart-confirm]');
    var required = Boolean(box) || isRequired();
    var checked = Boolean(box && box.checked);

    root.querySelectorAll('[name="checkout"], .cart__checkout-button').forEach(function (btn) {
      if (required) {
        btn.setAttribute('data-uk-checkout-requires-confirm', '');
      } else {
        btn.removeAttribute('data-uk-checkout-requires-confirm');
      }
      if (cartLooksEmpty(root)) {
        btn.setAttribute('disabled', '');
      } else {
        btn.disabled = false;
        btn.removeAttribute('disabled');
      }
    });

    extraButtons(root).forEach(function (extra) {
      extra.hidden = required && !checked;
    });
  }

  function syncAll() {
    ensureCheckboxes();
    getRoots().forEach(syncRoot);
  }

  window.syncUkCartConfirm = syncAll;

  function setConfirmError(on) {
    document.querySelectorAll('[data-uk-cart-confirm-wrap]').forEach(function (wrap) {
      wrap.classList.toggle('is-error', on);
    });
  }

  function onConfirmToggle(input) {
    if (!input || !input.matches || !input.matches('[data-uk-cart-confirm]')) return;
    var checked = input.checked;
    document.querySelectorAll('[data-uk-cart-confirm]').forEach(function (box) {
      box.checked = checked;
    });
    if (checked) setConfirmError(false);
    getRoots().forEach(syncRoot);
  }

  document.addEventListener('change', function (event) {
    onConfirmToggle(event.target);
  }, true);

  document.addEventListener('input', function (event) {
    onConfirmToggle(event.target);
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.matches && target.matches('[data-uk-cart-confirm]')) {
      onConfirmToggle(target);
      return;
    }

    var wrap = target.closest('[data-uk-cart-confirm-wrap], .uk-cart-confirm__label');
    if (!wrap) return;
    var input = wrap.querySelector('[data-uk-cart-confirm]');
    if (!input) return;

    window.setTimeout(function () { onConfirmToggle(input); }, 0);
    window.setTimeout(function () { onConfirmToggle(input); }, 80);
  }, true);

  document.addEventListener('touchend', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var wrap = target.closest('[data-uk-cart-confirm-wrap], .uk-cart-confirm__label');
    if (!wrap) return;
    var input = wrap.querySelector('[data-uk-cart-confirm]');
    if (!input) return;

    window.setTimeout(function () {
      if (input.checked) onConfirmToggle(input);
    }, 30);
  }, { capture: true, passive: true });

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('[name="checkout"], .cart__checkout-button');
      if (!btn) return;
      var root = rootFrom(btn) || document.querySelector('#main-cart-footer [data-uk-cart-confirm-root], #main-cart-footer .cart__ctas');
      if (!root) return;
      var box = root.querySelector('[data-uk-cart-confirm]');
      if (box && !box.checked) {
        event.preventDefault();
        event.stopPropagation();
        setConfirmError(true);
        box.focus();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      var box = form.querySelector('[data-uk-cart-confirm]');
      if (!box) {
        var formId = form.getAttribute('id');
        if (formId) box = document.querySelector('[data-uk-cart-confirm][form="' + formId + '"]');
      }
      if (box && !box.checked) {
        event.preventDefault();
        event.stopPropagation();
        setConfirmError(true);
        box.focus();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  document.addEventListener('shopify:section:load', syncAll);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncAll);
  }

  var scheduled = false;
  var syncing = false;
  function scheduleSync() {
    if (scheduled || syncing) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      if (syncing) return;
      syncing = true;
      try {
        syncAll();
      } finally {
        syncing = false;
      }
    });
  }

  function observe(el) {
    if (!el) return;
    new MutationObserver(function () {
      if (syncing) return;
      scheduleSync();
    }).observe(el, { childList: true, subtree: true });
  }

  observe(document.getElementById('CartDrawer'));
  observe(document.getElementById('main-cart-footer'));
})();
